<template>
  <div class="bg-white rounded p-2">
    <nav class="custom-tab-menu w-100 text-center">
      <h2>{{ $t("question-set.organization") }}</h2>
    </nav>
    <div class="mt-4">
      <file-manager scope="FINDING"></file-manager>
    </div>
  </div>
</template>

<script>
import FileAccessingMembersForm from "./file-accessing-members-form.vue";
import FileCategoryForm from "./file-category-form.vue";
import FileHistory from "./file-history.vue";
import FileManager from "./file-manager";
import FileUpload from "./file-upload.vue";

export default {
  props: ["scope"],
  components: {
    FileCategoryForm,
    FileUpload,
    FileAccessingMembersForm,
    FileHistory,
    FileManager,
  },

  watch: {},
  computed: {},
};
</script>
<style scoped>
.category-item .trash-icon {
  visibility: hidden; /* Varsayılan olarak gizle */
}

.category-item:hover .trash-icon {
  visibility: visible; /* Hover durumunda göster */
}
.custom-tab-menu {
  display: flex;
  justify-content: center;
  align-items: center;
  /* border-bottom: 1px solid #d6d7df; */
  background-color: #fff;
  width: max-content;

  div {
    padding: 0.62rem 2rem;
    color: #071437;
    font-size: 1.125rem;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    border-bottom: 2px solid transparent;
    cursor: pointer;

    &:hover,
    &.active {
      color: #ff7c48;
      background-color: transparent;
      border-color: #ff7c48;
    }
  }
}
</style>
